import isOffline from '@/core/isOffline';

let getUserName = function(state) {
	return state.currentUser.displayName;
};

let getUser = function(state) {
	return state.currentUser;
};

let getUserHasAdminAccess = function(state) {
	if (isOffline()) return true;
	return (state.isVerified && state.isSuper);
};

// let isLoggedIn = function(state) {
// 	return state.isLoggedIn;
// };

let isTimpexSupport = function(state) {
	return state.currentUser.email === 'support@timpex.no';
};

// let isVerified = function(state) {
// 	return state.isVerified;
// };

// let isSuper = function(state) {
// 	return state.isSuper;
// };

let company = function(state) {
	return state.companies.find(c => c.id === state.transporterCode);
};

export default {
	getUserName,
	getUser,
	getUserHasAdminAccess,
	company,
	isTimpexSupport
};
